import { Component, OnInit, ViewChild } from '@angular/core';
import { Howl } from 'howler';
import { IonRange, ModalController, NavParams, MenuController } from "@ionic/angular";
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { BibleService } from 'src/app/services/bible.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {TranslationService} from "../../services/translation.service";


export interface Track {
    name: string;
    path: string;
}

@Component({
    selector: 'app-seeker-request-bible-version',
    templateUrl: './seeker-request-bible-version.component.html',
    styleUrls: ['./seeker-request-bible-version.component.scss'],
})

export class SeekerRequestBibleVersionComponent implements OnInit {
    playlist: Track[] = [
        {
            name: 'Genesis 1:1',
            path: './assets/a.mp3'
        },
        {
            name: 'Exodus',
            path: './assets/b.mp3'
        }
    ];
    activeTrack: Track = null;
    player: Howl = null;
    isPlaying = false;
    progress = 0;

    current_sound_id: any;
    current_total_duration: any;
    current_duration: any;
    readRange: boolean = false;

    BibleBooksText: any;
    bookName;
    bookOrder;
    chapterId;
    language;
    rootPath: any;
    audio_dam_id;
    book_id;
    chapterAudio;
    audioUrl;
    currentVerse;
    verse;
    bookstext;
    dummyResp;
    showCheckBox;


    @ViewChild('range') range: IonRange;
    constructor(
        public modalController: ModalController,
        private _bibleService: BibleService,
        private loaderService: PtyLdService,
        //private router: Router,
        public menuCtrl: MenuController,
        private route: ActivatedRoute,
        public navParams: NavParams,
        private _translationService: TranslationService

    ) { }
    start(track: Track) {
        const self = this;
        if (this.player) {
            this.player.stop();
        }
        this.player = new Howl({
            // src: [track.path],
            src: [track],
            html5: true,
            onplay: () => {
                //   this.isPlaying = true;
                this.activeTrack = track;
                this.updateProgress();
            },
            onend: () => {

            }
        });
        // this.player.play();

        this.player.once('load', function () {
            // self.player.play();
            self.current_sound_id = self.player.play();
            self.current_total_duration = self.intoMinutes(self.player.duration(self.current_sound_id));
            self.player.stop(self.current_sound_id);
            self.isPlaying = false;
            if (self.player) {
                self.player.stop();
            }
        });
    }



    ngOnInit() {




        const dam_id = this.navParams.get('dam_id');
        const book_id = this.navParams.get('book_id');
        const chapter_id = this.navParams.get('chapter_id');
        this.language = this.navParams.get('language');

        const bookstext = dam_id + '2ET';
        this.audio_dam_id = dam_id + '2DA';
        this.book_id = book_id;
        this.chapterId = chapter_id;
        this.bookstext = bookstext;
        this.getBibleBooksText(bookstext, book_id, chapter_id);
        this.getAudioLocation();

    }
    showCheckBoxes() {
        this.showCheckBox = true;
    }

    showOptions($event, verse) {
        verse.selected = true;
    }

    getSelectedVerses($event, verse) {
        if ($event) {

            this.BibleBooksText.map((item) => {
                if (item.verse_id == verse.verse_id) {
                    item.isChecked = true;
                }
            });
        } else {
            this.BibleBooksText.map((item) => {
                if (item.verse_id == verse.verse_id) {
                    item.isChecked = false;
                }
            });
        }

    }

    getBibleBooksText(dam_id, book_id, chapter_id) {
        const self = this;
        const data = localStorage.getItem('verseInStorage');
        self.loaderService.showLoading(true, {}).then(() => {
            self._bibleService.getChapterText(dam_id, book_id, chapter_id).subscribe((result) => {
                this.BibleBooksText = result;
                this.bookName = this.BibleBooksText[0].book_name;
                this.bookOrder = this.BibleBooksText[0].book_order;
                this.chapterId = this.BibleBooksText[0].chapter_id;
                self.loaderService.showLoading(false);



                if (data) {
                    const verseInStorage = JSON.parse(data);

                    verseInStorage.forEach(element => {
                        this.BibleBooksText.map((item, index) => {
                            if (item.book_id == element.book_id && item.chapter_id == element.chapter_id && item.verse_id == element.verse_id) {
                                item.isHighlighted = true;
                                item.isChecked = false;
                            }
                        });
                    });

                }



            }, (err: any) => {
                console.error('Error loading Chapter Text', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }


    getBookChapterAudios() {
        const self = this;
        self.loaderService.showLoading(false, {}).then(() => {
            self._bibleService.getBookChapterAudio(this.audio_dam_id, this.book_id).subscribe((res) => {
                self.loaderService.showLoading(false);

                this.dummyResp = res;
                if (res) {
                    this.chapterAudio = this.dummyResp.find(x => x.chapter_id == this.chapterId);
                    if (this.chapterAudio && this.rootPath) {
                        this.audioUrl = this.rootPath + '/' + this.chapterAudio.path;
                        this.start(this.audioUrl);
                    }
                }
            }, (err: any) => {
                console.error('Error loading Languages', err);
                self.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }


    getAudioLocation() {
        // getting audio location from API through Service
        this._bibleService.getAudioLocation().subscribe(async (res: any) => {
            if (res) {
                this.rootPath = res[0].protocol + '://' + res[0].server + res[0].root_path;
                this.getBookChapterAudios();
            } else if (!res) {
                console.error('Error getting Path', res.message);
            }
        });
    }


    setCurrentVerse(verseText, verse) {
        this.currentVerse = verseText;
        this.verse = verse;
    }


    highlightVerse() {
        //   localStorage.setItem('verseInStorage','');

        let verseInStorage;
        const data = localStorage.getItem('verseInStorage');

        if (data) {
            verseInStorage = JSON.parse(data);
            let indexOfVerse;
            const found = verseInStorage.find((item, index) => {
                if (item.book_id == this.verse.book_id && item.chapter_id == this.verse.chapter_id && item.verse_id == this.verse.verse_id) {
                    indexOfVerse = index;
                    return true;
                }
            });

            if (found) {
                // remove existing element
                verseInStorage.splice(indexOfVerse, 1);
                localStorage.setItem('verseInStorage', JSON.stringify(verseInStorage));
                this.getBibleBooksText(this.bookstext, this.book_id, this.chapterId);
            } else {
                verseInStorage.push(this.verse);
                localStorage.setItem('verseInStorage', JSON.stringify(verseInStorage));
                this.getBibleBooksText(this.bookstext, this.book_id, this.chapterId);
            }
        } else {
            // add for first time
            const arr = [];
            arr.push(this.verse);
            localStorage.setItem('verseInStorage', JSON.stringify(arr));
            this.getBibleBooksText(this.bookstext, this.book_id, this.chapterId);
        }
    }

    intoMinutes(second) {
        let minutes = Math.floor(second / 60);
        let seconds = Math.floor(second - minutes * 60);

        return minutes + ':' + seconds;
    }

    togglePlayer(pause) {
        this.isPlaying = !pause;
        if (pause) {
            this.player.pause();
        } else {
            this.player.play();
        }
    }

    next() {
        const index = this.playlist.indexOf(this.activeTrack);
        if (index != this.playlist.length - 1) {
            this.start(this.playlist[index + 1]);
        } else {
            this.start(this.playlist[0]);
        }
    }

    prev() {
        const index = this.playlist.indexOf(this.activeTrack);
        if (index > 0) {
            this.start(this.playlist[index - 1]);
        } else {
            this.start(this.playlist[this.playlist.length - 1]);
        }
    }

    seek() {
        const newValue = +this.range.value;
        // let duration = this.player.duration();
        // this.player.seek(duration * (newValue / 100));
    }

    updateProgress() {
        const seek = Math.floor(this.player.seek());
        this.current_duration = this.intoMinutes(seek);
        this.progress = (seek / this.player.duration()) * 100 || 0;
        setTimeout(() => {
            this.updateProgress();
        }, 100);
    }

    forward() {
        const seek = Math.floor(this.player.seek());
        this.player.seek(seek + 10);
    }

    backward() {
        const seek = Math.floor(this.player.seek());
        this.player.seek(seek - 10);
    }

    // opening modal to share
    async shareVerse() {
        const multipleVersesArray = [];
        let count = 1;
        this.BibleBooksText.forEach((element, index) => {
            if (element.isChecked) {
                count += 3;
                const detailedverse = `${element.verse_text}<br>  Bibble: ${this.bookName}   Chapter:${this.chapterId}   Verse :${index + 1}<br>`;
                multipleVersesArray.push(detailedverse);
                multipleVersesArray.splice(count, 0, "<br><br>");
            }
        });
        if (multipleVersesArray.length > 0) {
            const finalverse = multipleVersesArray.join("");
            this.currentVerse = finalverse;
        } else {
            this.currentVerse = `Bibble: ${this.bookName}   Chapter:${this.chapterId}   Verse :${this.verse.verse_id}<br><br> ${this.verse.verse_text}`;
        }
        const data = {
            verse_text: this.currentVerse,
            book_name: this.bookName,
            chapter: this.chapterId,
            bookOrder: this.bookOrder,
        };
        await this.modalController.dismiss(data);
    }

    close() {
        this.modalController.dismiss();
    }
}
